import { render, staticRenderFns } from "./TemasForm.vue?vue&type=template&id=21b5c3b5&"
import script from "./TemasForm.vue?vue&type=script&lang=js&"
export * from "./TemasForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports